import { sparkToast } from '@spark';
import { data_from_server_post } from '@/shared/http/client';

/**
 * Checks if a dataset with the given name already exists in the system.
 * 
 * @param {string} datasetName - The name of the dataset to check (without file extension)
 * @returns {Promise<boolean>} - Returns true if dataset exists, false otherwise
 */
export async function checkDatasetExists(datasetName) {
  return new Promise((resolve) => {
    data_from_server_post(
      "is-dataset-exists",
      datasetName,
      (response) => {
        resolve(response.result || false);
      },
      (error) => {
        console.error('Error checking dataset existence:', error);
        resolve(false);
      }
    );
  });
}

export function recalculate_score(clientId, dataset) {
  if (!dataset) {
    sparkToast.error('Missing dataset information');
    return;
  }
  if (!clientId) {
    sparkToast.error('Missing client ID information');
    return;
  }

  data_from_server_post(
    "recalculate_score",
    {
      client_id: clientId,
      dataset: dataset
    },
    (response) => {
    },
    (error) => {
      sparkToast.error(`Failed to updated scores: ${error}`);
    }
  );
}

/**
 * Add a new label to a dataset (persistently)
 * @param {string} client_id
 * @param {string} dataset
 * @param {string} label
 * @param {function} onSuccess
 * @param {function} onError
 */
export function addLabelToDataset(llm_usecase_id, entity, onSuccess, onError) {
  data_from_server_post(
    'add-entity',
    { llm_usecase_id, entity },
    (result) => {
      if (result && !result.already_exists) {
        onSuccess && onSuccess(result);
      } else if (result && result.already_exists) {
        sparkToast.info(result.message);
        onSuccess && onSuccess(result);
      } else {
        onError && onError(result);
      }
    },
    (err) => {
      sparkToast.error('Failed to add label');
      onError && onError(err);
    }
  );
}


export function deleteEntityFromDataset(llm_usecase_id, dataset, entity, onSuccess, onError, deleteEntities = false, recordId = null) {
  data_from_server_post(
    'delete-entity',
    { llm_usecase_id, entity, delete_entities: deleteEntities, record_id: recordId, dataset: dataset },
    (result) => {
      if (!result.detail) { // if no detail, then the label was deleted successfully
        onSuccess && onSuccess(result);
      } else {
        onError && onError(result);
      }
    },
    (err) => {
      sparkToast.error('Failed to delete label');
      onError && onError(err);
    }
  );
}

export function renameEntityInDataset(llm_usecase_id, dataset, oldEntity, newEntity, onSuccess, onError, recordId = null, onRefreshRecords = null) {
  data_from_server_post(
    'rename-entity',
    { llm_usecase_id, old_entity: oldEntity, new_entity: newEntity, record_id: recordId, dataset: dataset },
    (result) => {
      if (!result.detail) { // if no detail, then the entity was renamed successfully
        onSuccess && onSuccess(result);
        // Refresh records after successful rename
        if (onRefreshRecords) {
          onRefreshRecords();
        }
      } else {
        onError && onError(result);
      }
    },
    (err) => {
      sparkToast.error('Failed to rename entity');
      onError && onError(err);
    }
  );
}
